import { createFeatureSelector, createSelector } from '@ngrx/store';
import { companiesFeatureKey, CompaniesState } from './company.reducer';

export const selectCompaniesState =
  createFeatureSelector<CompaniesState>(companiesFeatureKey);

export const selectAllCompanies = createSelector(
  selectCompaniesState,
  (state: CompaniesState) => state.companies
);
